// components/skins/dashboard-data-table.js
export class DashboardDataTableHtml {
  datatableskin() {
    return `
      <div class="container-layout full-height has-aside">
        <!-- LEFT: Tree -->
        <div class="container-column is-aside bg-subcontainer w-aside-default">
          <div class="column-header">
            <div class="header-title has-icon">
              <span class="iconify" data-icon="mingcute:performance-line"></span>
              <h3>Site Tags</h3>
            </div>
          </div>
          <div class="container-body directory-view">
            <ul class="directory-list" role="tree">
              <!-- Filled: Site → Groups → Tags -->
            </ul>
          </div>
        </div>

        <!-- RIGHT: Tabs -->
        <div class="container-column">
          <div class="column-header">
            <div class="tab-list">
              <button class="tab-btn active" data-tab="parameters">Parameters</button>
              <button class="tab-btn" data-tab="general">General Data</button>
              <button class="tab-btn" data-tab="settings">Settings</button>
              <button class="tab-btn" data-tab="events">Events</button>
              <button class="tab-btn" data-tab="state">State</button>
              <button class="tab-btn" data-tab="subscriptions">Subscriptions</button>
            </div>
            <div style="margin-left: auto; display: flex; gap: 0.5rem; align-items: center;">
              <button id="btn-refresh-tags" title="Refresh">
                <span class="iconify" data-icon="ic:baseline-refresh"></span>
              </button>
              <button id="btn-open-dict" title="Dictionary">
                <span class="iconify" data-icon="material-symbols:book"></span>
              </button>
              <button id="btn-create-register" class="btn-primary">
                <span class="iconify" data-icon="material-symbols:add"></span> New
              </button>
            </div>
          </div>

          <div class="container-body">
            <!-- Parameters Tab -->
            <div id="tab-parameters" class="tab-content active">
              <div class="table-responsive">
                <table class="has-min-width data-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Value</th>
                      <th>Unit</th>
                      <th>Date</th>
                      <th>Period</th>
                      <th>Plot</th>
                      <th>Monitor</th>
                      <th>Import</th>
                      <th>Export</th>
                      <th>Bookmark</th>
                      <th>X-Segment</th>
                      <th>Info</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>

            <!-- Placeholder Tabs -->
            <div id="tab-general" class="tab-content">General Data (TBD)</div>
            <div id="tab-settings" class="tab-content">Settings (TBD)</div>
            <div id="tab-events" class="tab-content">Events (TBD)</div>
            <div id="tab-state" class="tab-content">State (TBD)</div>
            <div id="tab-subscriptions" class="tab-content">Subscriptions (TBD)</div>
          </div>
        </div>
      </div>
    `;
  }
}